/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C6a] "IS THIS ASKED POSITION STILL AWAITED?" — THE ONE TYPESCRIPT ANSWER.
 *
 *  ⚠️ AN EMPTINESS QUESTION, NEVER ARITHMETIC. A seat is awaited when nobody is named on it. There
 *  is no "named of asked" comparison anywhere, because a command position is never a number
 *  (FR-5.2.6b; `commandSeat.schema.ts` records why the model carries no count at all).
 *
 *  ⚠️ AND IT HAS EXACTLY ONE MQL TWIN — `SEAT_AWAITED` in `api/src/utils/commandSeat.util.ts` —
 *  which `commandSeatAwaited.test.ts` pins against this over every stored seat shape, an ABSENT
 *  officer field included. [C5b §3]'s lesson: nine expressions of one rule is how one of them hid.
 * ─────────────────────────────────────────────────────────────────────────────────
 */

/** A seat on the wire: awaited when nobody holds it. */
export const seatIsAwaited = (seat: { officer: unknown }): boolean =>
  seat.officer === null || seat.officer === undefined;

/**
 * ⚠️ WHO OWES A POSITION, AS THE CODES AN OPERATOR ALREADY READS — `CD`, or `CD · TALA` once a
 * division has handed it to a unit. `AddresseeCodes`' register, so the printed order, the bell and
 * the officer app say it one way. A unit asked directly reads the same: division, then unit.
 */
export const commandAddresseeCode = (division: { shortCode: string }, unit: { shortCode: string } | null): string =>
  unit === null ? division.shortCode : `${division.shortCode} · ${unit.shortCode}`;
